module.exports = __webpack_public_path__ + "static/media/pdf.ba173b4a.png";